import React, { useEffect } from 'react';
import { connect } from "react-redux";
import * as Urls from 'src/constants/EndpointUrls';

const DeskHomePage = (props) =>{
    return (
        <div className="row">
            <div className="col-sm-6 mb-4">
                <div className="card">
                    <div className="card-header">
                        Basic Features
                    </div>
                    <ul className="list-group">
                        <li className="list-group-item">
                            <a href={Urls.DESK_CLIENT} className="btn btn-outline-primary">Clients ({props.values.clientCount}) </a>                       
                        </li>
                        <li className="list-group-item">
                        <a href={Urls.DESK_PAYMENT_INFOS} className="btn btn-outline-primary">Payment Information ({props.values.paymentInfoCount})</a>
                        </li>
                        <li className="list-group-item">
                        <a href={Urls.DESK_SYSTEM_ANNOUNCE} className="btn btn-outline-primary">Announcement ({props.values.systemAnnounce})</a>
                        </li>
                        <li className="list-group-item">
                        <a href={Urls.DESK_CONFIRM_UPLOAD_FILE} className="btn btn-outline-primary">Check the FB data file</a>
                        </li>
                        <li className="list-group-item">
                        <a href={Urls.DESK_BILLINGS} className="btn btn-outline-primary">Invoice</a>
                        </li>
                        <li className="list-group-item">
                        <a href={Urls.DESK_CREDIT_CHARGES} className="btn btn-outline-primary">Credit Billing History</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="col-sm-6 mb-4">
                <div className="card">
                    <div className="card-header">
                       System 
                    </div>
                    <ul className="list-group">
                        <li className="list-group-item">
                            <a href={Urls.DESK_ADMIN_USERS} className="btn btn-outline-primary">Desk User</a>
                        </li>
                        <li className="list-group-item">
                            <a href={Urls.DESK_BATCH_LOGS} className="btn btn-outline-primary">Batch Log</a>
                        </li>
                        <li className="list-group-item">
                            <a href={Urls.DESK_SYNC_PAYMENT_INFO_FROM_SF_TO_CLIENT} className="btn btn-outline-primary">SF data import</a>
                        </li>
                        <li className="list-group-item">
                            <a href={Urls.DESK_REVISION_INSURANCE} className="btn btn-outline-primary">協会けんぽ料率改定 (For Japan)</a>
                        </li>
                        <li className="list-group-item">
                            <a href={Urls.DESK_SSO_SETTINGS} className="btn btn-outline-primary">Update SSO rate</a>
                        </li>
                        <li className="list-group-item">
                            <a href={Urls.DESK_BANK_BRANCHES} className="btn btn-outline-primary">Add bank branch</a>
                        </li>
                        <li className="list-group-item">
                            <a href={Urls.DESK_GROUP_COMPANY_SETTINGS} className="btn btn-outline-primary">Group Company Setting</a>
                        </li>
                        <li className="list-group-item">
                            <a href={Urls.DESK_CLIENT_CUSTOM_FEATURES} className="btn btn-outline-primary">Custom features Setting</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="col-sm-6 mb-4">
                <div className="card">
                    <div className="card-header">
                        Response to inquiries
                    </div>
                    <ul className="list-group">
                        <li className="list-group-item">
                            <a href={Urls.DESK_CLIENT_JOBS_COMFIRMS} className="btn btn-outline-primary">CSV upload and linkage confirmation</a>
                        </li>
                        <li className="list-group-item">
                            <a href={Urls.DESK_KINTAI_RENKEI_COMFIRMS} className="btn btn-outline-primary">Confirmation of linkage with JOBCAN AM</a>
                        </li>
                        <li className="list-group-item">
                            <a href={Urls.DESK_CHANGE_KINTAI_SYNC_TIMES} className="btn btn-outline-primary">Remove the limit of time and attendance linkage</a>
                        </li>
                        <li className="list-group-item">
                            <a href={Urls.DESK_CHANGE_INFO_EMAILS} className="btn btn-outline-primary">Change Email</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default DeskHomePage;